<template>
  <v-skeleton-loader
    :loading="isLoading"
    transition="expand-transition"
    type="article"
  >
    <FormFactoryItem
      :FactoryItem="editStockItem"
      @save="save"
      @cancel="$router.push({name: from.name })" />
  </v-skeleton-loader>
</template>

<script>
import { mapActions, mapState } from 'vuex';
import loading from '@codehq/aurora-app-core/src/mixins/loading';
import FormFactoryItem from '../components/FormFactoryItem.vue';

export default {
  components: {
    FormFactoryItem,
  },
  name: 'EditFactoryItem',
  module: 'FactoryItem',
  mixins: [loading],
  data() {
    return {
      /**
      * Get/Set editing StockItem. Default to {}.
      */
      editStockItem: {},
      /**
       * Query Id for StockItem
       */
      stockItemId: this.$route?.query.id,
    };
  },
  computed: {
    /** Vuex states
     */
    ...mapState('factoryItems', ['factoryItems', 'factoryItem']),
  },
  async mounted() {
    this.isLoading = true;
    this.editStockItem = await this.LOAD_stockItem(this.stockItemId);
    this.isLoading = false;
  },
  methods: {
    /** Vuex methods
     */
    ...mapActions('stockItems', ['LOAD_stockItem', 'CREATE_stockItem', 'UPDATE_stockItem']),
    /** Method used to save the item
     */
    async save(stockItem) {
      const {
        id,
        brandId,
        packSize,
        processingMass,
      } = stockItem;
      await this.UPDATE_stockItem({
        id,
        brandId,
        packSize,
        processingMass,
      });
      this.$router.push({ name: 'processing-ListFactoryItem' });
    },
  },
};
</script>

<docs>
# EditFactoryItem example

'''js
<EditFactoryItem :FactoryItem="FactoryItem" />
'''
</docs>
